const en = {
  questionPaperLibrary: "Question Paper Library",
  questionPaperLibraryDescription:
    "Your dynamic workspace for crafting individual questions and designing comprehensive question papers.",
  assessmentLibrary: "Assessment Library",
  assessmentLibraryDescription:
    "Manage schedules, invite participants, and track performance reports in one centralized hub.",
  myAssessmentWidgetTitle: "My Assessment",
  myPreferences: "My Preferences",
  assessmentsForYou: "Assessments For You",
  exploreAssessmentsAssignedToYou: "Explore assessments assigned to you",
  hitachiAcademy: "Hitachi Academy",
  essentialBusinessKnowledgeTestForYou:
    "Essential Business Knowledge Test for you",
  continuousLearningJourneyDescription:
    "Designed to help you understand and strengthen your business skill throughout your continuous learning journey",
  noActiveAssessmentsScheduledForYou: "No Active Assessments Scheduled For You",
  upcoming: "Upcoming",
  notAttempted: "Not Attempted",
  myAssessmentCardDescription:
    "This assessment evaluates your technical, analytical, and problem-solving skills as part of GlobalLogic's campus hiring process.",
  totalDuration: "Total Duration",
  startTime: "Start Time",
  questionAuthoring: "Question Authoring",
  reviewQuestions: "Review Questions",
  bulkUploadHistory: "Bulk Upload History",
  bulkActionHistory: "Bulk Action History",
  editQuestion: "Edit Question",
  inviteParticipants: "Invite Participants",
  externalUserBulkUploadHistory: "External User Bulk Upload History",
  assessmentSchedule: "Assessment Schedule",
  assessmentReport: "Assessment Report",
  bulkHistory: "Bulk History",
  myUpload: "My Upload",
  bulkUpload: "Bulk Upload",
  createQuestion: "Create Question",
  bulkUploadQuestions: "Bulk Upload Questions",
  filters: "Filters",
  clear: "Clear",
  searchByTitle: "Search by title",
  refresh: "Refresh",
  refreshing: "Refreshing",
  reviewQuestionPapers: "Review Question Papers",
  myQuestionPapers: "My Question Papers",
  viewQuestionBank: "View Question Bank",
  createNew: "Create New",
  sortBy: "Sort By",
  state: "State",
  reviewed: "Reviewed",
  reviewedTooltip:
    "Show question papers that have been reviewed and published.",
  all: "All",
  draft: "Draft",
  published: "Published",
  inReview: "In Review",
  sentBack: "Sent Back",
  readyToPublish: "Ready to Publish",
  draftDescription:
    "The question paper creation is still in progress and not yet available to the learners",
  publishedDescription:
    "The question paper is live and accessible to the learners",
  inReviewDescription:
    "The question paper is under review and not yet approved",
  sentBackDescription: "The question paper has been sent back for revisions",
  readyToPublishDescription: "The question paper is ready to be published",
  createdAt: "Created at",
  updatedAt: "Updated at",
  publishedAt: "Published at",
  descending: "Descending",
  ascending: "Ascending",
  success: "Success",
  error: "Error",
  warning: "Warning",
  info: "Info",
  yes: "Yes",
  no: "No",
  noMatchingContentFound: "No matching content found",
  noQuestionPapersAvailableForReview: "No question papers available for review",
  questionPaperNotYetCreated: "Question paper not yet created",
  createQuestionPaperDescription:
    "Create a question paper to evaluate learners' skills and knowledge",
  createYourFirstQuestionPaper: "Create Your First Question Paper",
  createQuestionPaperModalTitle: "Create Question Paper",
  questionsTab: "Questions",
  questionPaperSettingsTab: "Question Paper Settings",
  editQuestionPaper: "Edit Question Paper",
  save: "Save",
  publish: "Publish",
  sendForReview: "Send for Review",
  sendingForReview: "Sending for Review",
  publishing: "Publishing",
  clone: "Clone",
  delete: "Delete",
  view: "View",
  edit: "Edit",
  close: "Close",
  create: "Create",
  creating: "Creating",
  confirm: "Confirm",
  cancel: "Cancel",
  version: "Version",
  untitled: "Untitled",
  noVersion: "No version",
  title: "Title",
  status: "Status",
  action: "Action",
  createdBy: "Created By",
  createNewVersion: "+ New Version",
  createNewVersionTitle: "Create New Version",
  deleteQuestionPaperPrompt:
    "Are you sure you want to delete this question paper?",
  deleteQuestionPaperWithTitlePrompt:
    "Do you want to delete this question paper titled '{{title}}'?",
  cloneQuestionPaperPrompt: "Do you want to clone this question paper?",
  publishQuestionPaperPrompt:
    "Are you sure you want to publish this question paper?",
  sendForReviewQuestionPaperPrompt:
    "Are you sure you want to send this question paper for review?",
  successfullyDeletedQuestionPaper: "Successfully deleted the question paper",
  successfullyMovedQuestionPaperToDraft:
    "Successfully moved the question paper to draft",
  successfullySavedQuestionPaperData: "Successfully saved question paper data",
  successfullyClonedQuestionPaper: "Successfully cloned the question paper",
  successfullyCreatedQuestionPaper: "Successfully created the question paper",
  validationFailedWithFollowingErrors:
    "Validation failed with the following errors:",
  failedStatusUpdateOf: "Failed status update of:",
  savedWithFollowingWarnings: "Saved with the following warnings:",
  reviewedAndPublished: "Reviewed and Published",
  deleting: "Deleting...",
  cloning: "Cloning...",
  assessment: "Assessment",
  public: "Public",
  private: "Private",
  visibility: "Visibility",
  questionType: "Question Type",
  selectQuestionTypeAndVisibility: "Select Question Type and Visibility",
  singleChoice: "Single Choice",
  multipleChoice: "Multiple Choice",
  trueOrFalse: "True or False",
  fillInTheBlanks: "Fill in the blanks",
  codingQuestion: "Coding Question",
  subjectiveQuestion: "Subjective Question",
  speakingQuestion: "Speaking Question",
  downloadTemplateEditAndReuploadQuestions:
    "Download template, edit and re-upload the list of questions",
  downloadExcelTemplateInstruction:
    "Download the Excel template using the button below.",
  addQuestionsToSheetInstruction:
    "Add your questions to the sheet (instructions are included inside).",
  uploadCompletedExcelInstruction:
    "Upload the completed Excel file to bulk import questions.",
  uploading: "Uploading...",
  uploadQuestions: "Upload Questions",
  completed: "Completed",
  invalid: "Invalid",
  initiated: "Initiated",
  failed: "Failed",
  fileName: "File Name",
  templateType: "Template Type",
  uploadedAt: "Uploaded At",
  actions: "Actions",
  mcqTemplate: "MCQ Template",
  fibTemplate: "FIB Template",
  monitorUploadExcelDescription:
    "Monitor each upload Excel file, check how many questions were added or failed, and view error details if needed.",
  reset: "Reset",
  showing: "Showing",
  to: "to",
  of: "of",
  results: "results",
  noExcelFound: "No Excel Found",
  cloneAssessmentConfirmation: "Clone Assessment Confirmation",
  cloneAssessmentWithTitlePrompt:
    "Are you sure you want to clone this assessment titled '{{title}}'?",
  successfullyClonedAssessment: "Assessment cloned successfully",
  newVersionContentPrompt:
    "You're about to create a new version of this content. Any further changes will be saved to this version. Would you like to continue?",
  createVersionWithNumber: "Create (V{{version}})",
  addYourComment: "Add your comment",
  maxLimitReached: "max limit reached",
  deleteContentPrompt: "Are you sure you want to delete this {{contentType}}?",
  deleteContentWithTitlePrompt:
    "Are you sure you want to delete this {{contentType}} titled '{{title}}'?",
  schedulePreview: "Schedule Preview",
  reschedule: "Reschedule",
  cancelled: "Cancelled",
  copyLink: "Copy Link",
  assessmentIsCancelled: "Assessment is cancelled",
  deleteConfirmation: "Delete Confirmation",
  cancelConfirmation: "Cancel Confirmation",
  deleteAssessmentPrompt: "Are you sure you want to delete this assessment?",
  cancelAssessmentPrompt: "Are you sure you want to cancel this assessment?",
  rescheduleAssessment: "Reschedule Assessment",
  customTermsAndConditions: "Custom Terms and Conditions",
  viewTermsAndConditions: "View T&C",
  scheduleNewAssessment: "Schedule New Assessment",
  selectQuestionPaper: "Select Question Paper",
  createAssessment: "Create Assessment",
  failedToLoadData: "Failed to load data!",
  assessmentNotYetCreated: "Assessment not yet created",
  createAssessmentDescription:
    "Create an assessment to evaluate the skills and knowledge of learners",
  createYourFirstAssessment: "Create Your First Assessment",
  failedToLoadSchedules: "Failed to Load Schedules",
  errors: "Errors:",
  basicInformation: "Basic Information",
  assessmentName: "Assessment Name",
  na: "NA",
  scheduleInstructions: "Schedule Instructions",
  noInstructionsProvided: "No instructions provided",
  accessCriteria: "Access Criteria",
  searchTags: "Search Tags",
  viewAttributes: "View Attributes",
  termsAndConditions: "Terms & Conditions",
  enabled: "Enabled",
  disabled: "Disabled",
  requireCandidatesToAcceptTerms:
    "Require candidates to accept T&C before starting the assessment",
  proctoringSettings: "Proctoring Settings",
  enableVideoProctoring: "Enable Video Proctoring",
  maximumVideoViolationsAllowed: "Maximum video violations allowed",
  enableBrowserProctoring: "Enable Browser Proctoring",
  maximumBrowserViolationsAllowed: "Maximum browser violations allowed",
  displayViolationsToCandidates: "Display Violations to Candidates",
  actionWhenViolationLimitReached: "Action When Violation Limit Reached",
  flagged: "Flagged",
  terminate: "Terminate",
  stakeholdersAndFeedback: "Stakeholders and Feedback",
  owner: "Owner",
  recruiter: "Recruiter",
  allowCandidateFeedback: "Allow Candidate Feedback",
  enableCandidateFeedbackDescription:
    "Enable candidates to submit feedback after completing the assessment",
  schedulingAndTimerSettings: "Scheduling & Timer Settings",
  scheduleType: "Schedule Type",
  loginWindow: "Login Window",
  durationBased: "Duration Based",
  deadline: "Deadline",
  autoCompleteMode: "Auto-complete Mode",
  startDateAndTime: "Start Date & Time",
  loginWindowInMinutes: "Login Window (in minutes)",
  endDateAndTime: "End Date & Time",
  timerEnabled: "Timer Enabled",
  assessmentRules: "Assessment Rules",
  assessmentPattern: "Assessment Pattern",
  resultVisibility: "Result Visibility",
  passPercentage: "Pass Percentage",
  maximumAttemptsAllowed: "Maximum Attempts Allowed",
  unlimitedAttempts: "Unlimited Attempts",
  attempt: "attempt",
  attempts: "attempts",
  coolOffPeriodBetweenAttempts: "Cool Off Period Between Attempts",
  questionDisplaySettings: "Question Display Settings",
  showQuestionTitle: "Show Question Title",
  showQuestionTitleDescription:
    "Display the question title above each question",
  showHint: "Show Hint",
  hintLoading: "You need to wait before you see another hint",
  allHintsShown: "No hints are pending",
  showHintDescription:
    "Enable hints to assist candidates during the assessment",
  showExplanation: "Show Explanation",
  hideExplanation: "Hide Explanation",
  showExplanationDescription:
    "Show explanations after each question submission",
  showQuestionMarks: "Show Question Marks",
  showQuestionMarksDescription:
    "Display the mark/score value for each question",
  showWatermark: "Show Watermark",
  showWatermarkDescription:
    "Display the email of the candidate for each question as a watermark",
  questionPaperPreview: "Question Paper Preview",
  questionPaperReview: "Question Paper Review",
  createSchedule: "Create Schedule",
  reviewerComments: "Reviewer Comments",
  reviewComments: "Review Comments",
  sendBackQuestionPaperPrompt:
    "Are you sure, you want to send back this question paper?",
  moveQuestionPaperToDraftPrompt:
    "Are you sure, you want to move this question paper to draft?",
  markQuestionPaperReadyToPublishPrompt:
    "Are you sure, you want to mark this question paper ready to publish?",
  questionPaperStatusUpdatedSuccessfully:
    "Question paper status updated successfully!",
  newVersionQuestionPaperCreatedSuccessfully:
    "New version for question paper created successfully!",
  questionPaperClonedSuccessfully: "Question paper cloned successfully!",
  startAddingQuestionsPreview: "Start adding questions to preview it here",
  bulkInviteParticipants: "Bulk Invite Participants",
  bulkInviteParticipantsDescription:
    "Invite multiple participants at once by uploading a pre-filled Excel file. Please use the template provided to ensure the correct format.",
  maxParticipantsPerFileNote:
    "Max 200 participants per file. Duplicate or invalid entries will be skipped with an error.",
  downloadTemplate: "Download Template",
  creatingUser: "Creating User...",
  bulkInviteLabel: "Bulk Invite",
  createAndInvite: "Create & Invite",
  myUploads: "My Uploads",
  enterIndividualsForInvite:
    "Enter the names of one or more individuals you wish to invite for the assessment",
  searchPeopleByEmailOrName: "Search people by Email ID or name",
  noResultsFound: "No results found",
  loading: "Loading...",
  or: "or",
  multipleEmailsInviteDescription:
    "Add multiple user emails, separated by commas, to invite multiple users to the assessment",
  addCandidates: "Add Candidates",
  pleaseEnterValidNameOrEmail: "Please enter a valid name or email address",
  pleaseEnterValidEmailAddress: "Please enter a valid email address",
  someEmailsCouldNotBeAdded: "Some email addresses couldn't be added",
  checkInvalidEmailIds:
    "Please check the following email IDs - they seem to be invalid:",
  failedToSendInvitesFollowingEmails:
    "Failed to send invites to the following emails:",
  successfullyInvitedMembers: "Successfully invited {{count}} member",
  validationFailed: "Validation failed",
  excelUploadedSuccessfully: "Excel uploaded successfully",
  invalidBulkNominationTemplate: "Invalid Bulk Nomination Template",
  actionCompletedWithWarnings: "Action completed with the following warnings:",
  actionFailedWithErrors:
    "Action couldn't be completed and exited with the following errors:",
  trackBulkOperationsAndResults:
    "Track all your bulk operations and their results",
  partiallySaved: "Partially Saved",
  statusInitiatedDescription:
    "Question update request has been submitted and is being processed.",
  statusCompletedDescription:
    "All selected questions were updated successfully.",
  statusFailedDescription:
    "None of the selected questions could be processed successfully.",
  statusPartiallySavedDescription:
    "Some questions were saved successfully, while others encountered issues.",
  draftReadyToPublishToPublish: "Draft/Ready To Publish -> Publish",
  actionType: "Action Type",
  uploadedOn: "Uploaded On",
  viewDetails: "View Details",
  loadingRecords: "Loading records...",
  noRecordsFound: "No records found",
  recordsPerPage: "Records per page:",
  page: "Page",
  untitledQuestion: "Untitled Question",
  globalLogic: "GlobalLogic",
  aiGenerated: "AI Generated",
  fullScreen: "Full Screen",
  exitFullScreen: "Exit Full Screen",
  skills: "Skills",
  tags: "Tags",
  allowedCodingLanguages: "Allowed Coding Languages",
  marks: "Marks",
  lastUpdatedAt: "Last updated at",
  solutionCode: "Solution Code",
  solution: "Solution",
  starterCode: "Starter Code",
  options: "Options",
  explanation: "Explanation",
  hint: "Hint",
  deleteQuestion: "Delete Question",
  noSections: "No Sections added",
  editAndPublish: "Edit & Publish",
  sendBackToDraftInstruction:
    "Click the Send Back button to move the question back to draft.",
  updateStatusReadyToPublishInstruction:
    "Click the Ready to Publish button to update the status.",
  successfullyUpdatedStatus: "Successfully updated the status",
  dismiss: "Dismiss",
  ongoing: "Ongoing",
  toBeLaunched: "To Be Launched",
  contentExpired: "Content Expired",
  notApplicable: "Not Applicable",
  expiresSoon: "Expires Soon",
  contentCreationInProgressTooltip:
    "The content creation is still in progress and not yet available to learners",
  contentLiveAccessibleTooltip:
    "The content is live and accessible to learners",
  contentAvailableWithinDatesTooltip:
    "The content is currently available, as it is within the launch and expiry dates",
  contentNotLaunchedAvailableOnTooltip:
    "The content has not launched yet and will be available on",
  contentExpiredOnTooltip: "This content expired on",
  statusAvailableAfterPublishTooltip:
    "Status will be available once the content is published",
  contentExpiresWithin48HoursTooltip:
    "The content is going to expire within 48 hours.",
  moveToDraftOrCloneToEdit: "move it to draft or clone it to make edits",
  webContent: "Web Content",
  eLearning: "E-Learning",
  untitledContent: "Untitled Content",
  sendToDraft: "Send to Draft",
  sendToDraftPublishedInstruction:
    "This content is already published. To make changes, click the Send to Draft button.",
  copyLinkForLearner: "Copy Link For Learner",
  questionPaperName: "Question Paper Name",
  type: "Type",
  duration: "Duration",
  minutes: "Minutes",
  difficultyLevel: "Difficulty Level",
  language: "Language",
  timezone: "Timezone",
  preferredLocation: "Preferred Location",
  notSelected: "Not Selected",
  selectedPreferencesHeading: "Selected Preferences",
  selectedPreferencesInfo: "Selected preferences for seamless experience",
  shortDescription: "Short Description",
  totalMarks: "Total Marks",
  questionPaperInstructions: "Question Paper Instructions",
  expiryDate: "Expiry Date",
  knowledgeCategory: "Knowledge Category",
  category: "Category",
  subCategory: "Sub-category",
  region: "Region",
  usage: "Usage",
  internalUseOnly: "Internal Use Only",
  externalUseOnly: "External Use Only",
  availableForAll: "Available for All",
  apac: "APAC",
  emea: "EMEA",
  latinAmerica: "Latin America",
  northAmerica: "North America",
  globalRegion: "Global",
  automotive: "Automotive",
  bankingFinancialServicesInsurance: "Banking, Financial Services & Insurance",
  connectivitySolutionsCommunication: "Connectivity Solutions/Communication",
  consumerRetail: "Consumer & Retail",
  healthcareLifeSciences: "Healthcare & Life Sciences",
  manufacturingAndIndustrial: "Manufacturing and Industrial",
  mediaEntertainment: "Media & Entertainment",
  technology: "Technology",
  other: "Other",
  behavioralInterpersonal: "Behavioral/Interpersonal",
  technical: "Technical",
  processAndTools: "Process and Tools",
  polishLanguage: "Polish",
  spanishLanguage: "Spanish",
  japaneseLanguage: "Japanese",
  germanLanguage: "German",
  ukrainianLanguage: "Ukrainian",
  swedishLanguage: "Swedish",
  romanianLanguage: "Romanian",
  slovakLanguage: "Slovak",
  croatianLanguage: "Croatian",
  englishUsLanguage: "English (US)",
  englishUkLanguage: "English (UK)",
  englishInLanguage: "English (IN)",
  netTech: "NET",
  aiMl: "AI/ML",
  automotiveStandardsProtocols: "Automotive Standards & Protocols",
  businessAnalysis: "Business Analysis",
  cCpp: "C/C++",
  cloudDataScience: "Cloud Data Science",
  bigData: "Big Data",
  dataAnalytics: "Data Analytics",
  databaseTech: "Database",
  developmentTools: "Development Tools",
  devops: "DevOps",
  embedded: "Embedded",
  javaTech: "Java",
  javaScriptTech: "JavaScript",
  linuxKernel: "Linux Kernel",
  mobileDev: "Mobile Dev",
  networking: "Networking",
  operatingSystemsServers: "Operating Systems & Servers",
  otherTech: "Other - Tech",
  productivityTools: "Productivity Tools",
  programmingLangOther: "Programming Lang - Other",
  pythonTech: "Python",
  phpTech: "PHP",
  qaAqa: "QA / AQA",
  softwareEngineering: "Software Engineering",
  uxUi: "UX/UI",
  architectureTech: "Architecture",
  golang: "Golang",
  requirementEngineeringTechnicalWriting:
    "Requirement Engineering/Technical Writing",
  onboarding: "Onboarding",
  glTools: "GL Tools",
  processAndPolicies: "Process and Policies",
  communicationSubCategory: "Communication",
  personalEffectiveness: "Personal Effectiveness",
  methodologies: "Methodologies",
  projectManagement: "Project Management",
  peopleManagement: "People Management",
  leadershipPrograms: "Leadership Programs",
  domain: "Domain",
  reviewer: "Reviewer",
  none: "None",
  questionPaperPreviewBreadcrumb: "Question Paper Preview: {{title}}",
  questionPaperInReviewContactReviewer:
    "This question paper is currently in review. Kindly contact the reviewer.",
  randomization: "Randomization",
  randomizationInSectionDescription:
    "Questions in this section will be shown in a random order to the candidates",
  questionPreviewPlaceholderImage: "Question preview placeholder",
  createNewVersionPromptWithNumber: "Create New Version (V{{version}})?",
  questionPreviewBreadcrumb: "Question Preview: {{title}}",
  questionPreviewTitle: "Question Preview",
  adminView: "Admin View",
  candidateView: "Candidate View",
  viewAsCandidate: "View As Candidate",
  closePanel: "Close panel",
  internalQuestion: "Internal Question",
  expiresOn: "Expires On",
  expiredLabel: "Expired",
  solutionNotAdded: "Solution not added",
  testCases: "Test Cases",
  testCasesNotAdded: "Test cases not added",
  starterCodeNotAdded: "Starter code not added",
  groupTitleLengthValidation:
    "Group title must be more than 5 characters and less than 120 characters",
  addTitleHere: "Add title here...",
  groupUpdatedSuccessfully: "Group updated successfully",
  groupDeletedSuccessfully: "Group deleted successfully",
  group: "Group",
  numberOfQuestionsToBeShown: "Number of questions to be shown",
  questionLimitPerSectionDescription:
    "Show only a certain number of questions to the candidates in the sections",
  numberOfQuestionsToShow: "Number of questions to show {{picked}}/{{total}}",
  collapseGroup: "Collapse group",
  expandGroup: "Expand group",
  groupSetupStartAddingQuestions:
    "A group is set up for this section. Start adding questions to it.",
  addMoreQuestions: "Add More Questions",
  addQuestionFromLibrary: "Add Question from Library",
  questionDeletedSuccessfully: "Question deleted successfully",
  questionsShownCountUpdated: "Number of questions shown has been updated",
  failedToDeleteQuestion: "Failed to delete question",
  caseSensitive: "Case sensitive",
  caseSensitiveDescription:
    "If enabled, learners must enter the answer with the exact same uppercase and lowercase letters.",
  enterYourAnswerBelow: "Enter Your Answer Below",
  caseSensitiveAnswerInfo:
    "This question is case sensitive so please enter your answers using the exact uppercase and lowercase letters.",
  answerWithNumber: "Answer {{number}}",
  visibleTestCases: "Visible Test Cases",
  hiddenTestCases: "Hidden Test Cases",
  visibleLabel: "Visible",
  hiddenLabel: "Hidden",
  responseSetting: "Response Setting",
  recordingLimit: "Recording Limit",
  minimumResponseDuration: "Minimum Response Duration",
  uploadLimit: "Upload Limit",
  practiceAllowed: "Practice Allowed",
  standardEvaluationRubricInfo:
    "This is the standard evaluation rubric that will be used to assess the candidate's response to this question.",
  criteria: "Criteria",
  weightPercentage: "Weight(%)",
  viewRemarks: "View Remarks",
  input: "Input",
  expectedOutput: "Expected Output",
  actualOutput: "Actual Output",
  untitledSection: "Untitled Section",
  testSectionDescription: "Test Section Description",
  groupAddedSuccessfully: "Group added successfully",
  addGroupToSection: "Add Group to Section",
  deleteSection: "Delete Section",
  questionPaperDetails: "Question Paper Details",
  skillsInfoMessage:
    "List the key skills this question paper is intended to evaluate.",
  contentSettings: "Content Settings",
  stakeholderAndReview: "Stakeholder and Review",
  statusType: "Status Type",
  notReviewed: "Not Reviewed",
  sourceType: "Source Type",
  proficiency: "Proficiency",
  beginner: "Beginner",
  intermediate: "Intermediate",
  advanced: "Advanced",
  wecp: "WECP",
  enterMarks: "Enter marks",
  removeSkill: "Remove skill",
  searchSkills: "Search skills",
  noSkillsFound: "No skills found.",
  enterTag: "Enter a tag",
  enterOwner: "Enter owner",
  enterReviewer: "Enter reviewer",
  noUserWithRole: "No such user with this role was found",
  savingData: "Saving data...",
  questionDataSavedSuccessfully: "Question data saved successfully",
  sendQuestionForReviewInstruction:
    "Click on Send for Review button to send it to reviewer to get it reviewed!",
  publishQuestionInstruction:
    "Click on publish button to publish the question.",
  noLearningContentAddedAfterSelectingYes:
    "No Learning Content added after selecting Yes",
  expectedTimeInMinutes: "Expected Time(in min)",
  codingMarksAutoCalculatedInfo:
    "This marks is calculated automatically based on the hidden test cases added to this question",
  skillsInfoMessageQuestion:
    "Provide specific skills that participants will acquire from question",
  skillsSubtitleQuestion: "Set the skills associated with this question",
  allowedCodingLanguagesInfoQuestion:
    "Choose languages available for solving this question",
  selectCodingLanguages: "Select coding languages",
  allLanguages: "All Languages",
  tagsInfoQuestion:
    "Provide keywords to categorize, describe, and identify the event",
  tagsSubtitleQuestion: "Set the tags for quick search",
  knowledgeCategorySubtitleQuestion:
    "Helps categorize questions by cognitive skill level.",
  explanationNotAvailableForSpeakingQuestion:
    "Explanation not available for Speaking Question",
  ownerVersionSyncInfo:
    "If we change the owner of this version it will also update in all the created versions.",
  ownerInfoMessage: "Select primary owner(s) of the question",
  ownerReviewerCannotBeSame: "owner and reviewer cannot be same",
  reviewerInfoMessage:
    "Select an individual or group of individuals as reviewer(s)",
  stakeholdersUpdatedSuccessfully: "Stakeholders updated successfully!",
  unexpectedErrorCreatingNewVersion:
    "An unexpected error occurred while creating a new version.",
  previewAndPublish: "Preview & Publish",
  viewAnalytics: "View Analytics",
  cloneQuestionPrompt: "Do you want to clone this question?",
  evaluationRubric: "Evaluation rubric",
  problemStatement: "Problem Statement",
  problemStatementPlaceholder:
    "Enter the Problem Statement or Statement for Quiz",
  addMoreOptions: "Add more options",
  answer: "Answer",
  addOptionsAndMarkCorrectAnswer: "Add options and Mark the correct answer",
  markCorrectAnswer: "Mark the correct answer",
  addCorrectAnswer: "Add correct answer",
  enterCorrectAnswerForBlank: "Enter the correct answer for blank {{number}}",
  blankWithNumber: "Blank {{number}}",
  addProblemStatementWithBlankToEnableAnswer:
    "Add a proper problem statement with a '&blank' to enable the answer.",
  enterSolution: "Enter the solution",
  enterExplanation: "Enter the Explanation",
  codingSolutionExplanationPlaceholder:
    "Briefly explain the logic, approach, and edge cases handled in the optimal solution",
  optionWithNumber: "Option {{number}}",
  enterExplanationForAnswer: "Enter the Explanation for Answer {{number}}",
  addOptionToEnableExplanation:
    "Add option {{number}} to enable the explanation.",
  enterExplanationForBlank: "Enter the Explanation for Blank {{number}}",
  addProblemStatementWithBlankToEnableExplanation:
    "Add a proper problem statement with a '&blank' to enable the explanation.",
  exitCodeBlockInfo:
    'To exit the code block, go to the end of the line and click "Enter" three times',
  fibBlankInsertionInfo:
    'To add a blank, select text and click on "Insert Blank" button, or manually add &blankN, where N can be any integer eg: &blank1;',
  htmlEditorAccessInfo:
    "To add code or have control over the format, you can access the HTML editor by clicking the edit icon",
  enterHint: "Enter the hint",
  addUpTo3Hints: "Add upto 3 hints",
  skillSelectionCannotBeEmpty: "Skill selection cannot be empty",
  inviteEmailsPlaceholder: "user1@globallogic.com,user2@globallogic.com",
  createSection: "Create Section",
  untitledGroup: "Untitled Group",
  createGroup: "Create Group",
  collapseSections: "Collapse Sections",
  expandSections: "Expand Sections",
  assessmentNamePlaceholder: "Please enter the assessment name",
  questionPaperTitleInfo:
    "Enter a clear, descriptive title for the question paper.",
  shortDescriptionPlaceholder: "Provide a Short Description",
  shortDescriptionInfo:
    "A brief summary explaining what the question paper covers.",
  questionPaperInstructionsInfo:
    "Write the instructions that candidates will see before starting the question paper. Include important details like section rules, question formats, navigation tips, and submission guidelines.",
  questionPaperInstructionsPlaceholder:
    "Add any important instructions for learners before they begin the assessment - duration, passing criteria, allowed tools, or guidelines.",
  totalMarksAutoCalculatedInfo:
    "Total marks will be automatically calculated based on the number of questions selected for each group. If the number of questions to be shown is set to 0, that group will be excluded from the total marks.",
  questionPaperType: "Question Paper Type",
  questionPaperTypeInfo: "Select the format of the question paper.",
  durationInfo:
    "Set the total time limit for completing the question paper (in minutes).",
  difficultyLevelInfo:
    "Select the expected difficulty level based on the candidate's experience.",
  languageInfo:
    "Choose the language in which the question paper will be presented.",
  tagsInfo:
    "Add keywords to help others find this question paper through a search.",
  selectCategory: "Select Category",
  createLevel: "Create",
  evaluate: "Evaluate",
  analyze: "Analyze",
  apply: "Apply",
  understand: "Understand",
  remember: "Remember",
  allowedCodingLanguagesRequiredInfo:
    "field is required only when you add coding questions to the question paper.",
  knowledgeCategoryInfo:
    "Select the cognitive skill level this question paper targets, e.g., Remember, Understand, Apply.",
  allowedCodingLanguagesInfo:
    "Select the programming languages permitted for coding questions in this question paper.",
  expiryDateInfo:
    "Set an optional date after which this question paper should no longer be used.",
  visibilityInfo: "Select the visibility of the question paper",
  visibilityLockedInfo:
    "Once a question paper is published with Public visibility, all its other versions will also have Public visibility. Similarly, if it is published as Private, all versions will remain Private.",
  reviewRequired: "Review Required",
  reviewRequiredLockedInfo:
    "The 'Review Required' setting is synced across all versions of a Question Paper. If any version is published with review enabled or disabled, the same setting will apply to all versions, and cannot be edited individually.",
  reviewRequiredInfo:
    "Enable if this question paper must go through a formal review process before publishing.",
  maxDurationInfo:
    "Maximum time allowed for a user to record their response for this question.",
  minDurationInfo:
    "Minimum required recording time a user must complete before submitting their response.",
  uploadLimitInfo:
    "Number of times a user can re-record their response before final submission.",
  textQuestionTitle: "This is a text question",
  audioRecordQuestionTitle: "This is an audio record question",
  audioUploadQuestionTitle: "This is an audio upload question",
  videoRecordQuestionTitle: "This is a video record question",
  videoUploadQuestionTitle: "This is a video upload question",
  subjectiveQuestionUploadConfigTitle:
    "Subjective Question Upload Config Title",
  recordingLimitInMinutes: "Recording Limit(in min)",
  minimumResponseDurationInMinutes: "Minimum Response Duration(in min)",
  recordingLimitLessThanTwenty: "Recording limit must be less than 20",
  recordingLimitGreaterThanOrEqualOne:
    "Recording limit must be greater than or equal to 1",
  minimumDurationLessThanRecordingLimit:
    "Minimum response duration must be less than Recording limit",
  durationGreaterThanPointFive: "Duration must be greater than 0.5",
  uploadLimitGreaterThanZero: "Upload limit must be greater than 0",
  addFieldSelectCodingLanguagesInfo:
    "To add a {{fieldLabel}}, please select allowed coding languages in the '{{basicDetails}}' section first.",
  basicDetails: "Basic Details",
  loadingEditor: "Loading editor...",
  run: "Run",
  writingSolutionInLanguage: "You're currently writing a solution in",
  changingToLanguageWillClearInput: "Changing to",
  unsavedChangesWillBeLostInLanguage: "Your unsaved changes in",
  changeLanguage: "Change Language",
  testCase: "Test Case",
  add: "Add",
  addMinimumVisibleAndHiddenTestCasesInfo:
    "Add minimum 2 visible test cases and 3 hidden test cases in the below",
  visibleToCandidatesForSelfEvaluation:
    "Visible to candidates for self-evaluation",
  noVisibleTestCasesAddedYet:
    "No visible test cases added yet. Click the button below to add one.",
  visibleTestCasesCannotExceedTwenty:
    "Visible testcases cannot be more than 20",
  addMoreVisibleTestCases: "Add more visible test cases",
  maximumTestCasesLimitReached: "Maximum testcases limit reached",
  hiddenToCandidatesRunsAfterSubmit:
    "Hidden to candidates, runs after candidate submits",
  noHiddenTestCasesAddedYet:
    "No hidden test cases added yet. Click the button below to add one.",
  hiddenTestCasesCannotExceedTen: "Hidden testcases cannot be more than 10",
  addMoreHiddenTestCases: "Add more hidden test cases",
  hiddenTestCase: "Hidden Test Case",
  visibleTestCase: "Visible Test Case",
  someQuestionsCouldNotBeUpdated:
    "Some questions couldn't be updated. Please review the questions and try again.",
  publishSummary: "Publish Summary",
  sendForReviewSummary: "Send for Review Summary",
  moveToDraftSummary: "Move to Draft Summary",
  actionSummary: "Action Summary",
  publishSummarySubtitle:
    "Here's the summary of your publish action. Review the details below.",
  sendForReviewSummarySubtitle:
    "Here's the summary of your review request. Review the details below.",
  moveToDraftSummarySubtitle:
    "Here's the summary of your move to draft action. Review the details below.",
  actionSummarySubtitle:
    "Here's the summary of your action. Review the details below.",
  successfully: "Successfully",
  failedTo: "Failed to",
  moveToDraft: "Move to Draft",
  details: "Details",
  questionTitle: "Question Title",
  reason: "Reason",
  showLess: "Show less",
  showMoreCount: "Show {{count}} more",
  uploadedAllCountItems: "Uploaded all {{count}} {{item}}",
  partiallyUploadedCountItems:
    "Partially uploaded {{successCount}}/{{totalCount}} {{item}}",
  users: "users",
  questions: "questions",
  viewErrors: "View Errors",
  errorsWithFileName: "Errors - {{fileName}}",
  inputIsRequired: "Input is required",
  expectedOutputIsRequired: "Expected output is required",
  expectedOutputCannotBeBlank:
    "Expected output must not be empty or just spaces",
  marksMustBeNumber: "Marks should be a number",
  marksAreRequired: "Marks are required",
  hiddenTestCaseMarksGreaterThanZero:
    "Marks for hidden test cases should be greater than 0 to proceed.",
  hiddenTestCaseMarksMaxThirtyThousand:
    "Marks for hidden test cases should not exceed 30,000.",
  explanationMinFiveIfProvided:
    "Explanation must be at least 5 characters if provided",
  explanationIsRequired: "Explanation is required",
  explanationMinFiveNotBlank:
    "Explanation must be at least 5 characters and not just spaces",
  provideInput: "Provide input",
  provideExpectedOutput: "Provide expected output",
  enterScore: "Enter score",
  optional: "optional",
  explainTestCase: "Explain the test case",
  updateTestCase: "Update Test Case",
  addTestCase: "Add Test Case",
  deleteQuestionWithTitlePrompt:
    "Are you sure you want to delete this question titled '{{title}}'?",
  errorFetchingData: "Error fetching data",
  rowNumber: "Row Number",
  columnName: "Column Name",
  useCase: "Use Case",
  startsAt: "Starts At",
  endsAt: "Ends At",
  invite: "Invite",
  viewReport: "View Report",
  successfullyDeletedAssessment: "Successfully deleted the assessment",
  successfullyFreezeActionAssessment: "Successfully {{action}} the assessment",
  freezeOperationFailed: "Freeze Operation Failed",
  deleteAssessmentWithTitlePrompt:
    "Are you sure you want to delete this assessment titled '{{title}}'?",
  freeze: "Freeze",
  unfreeze: "Unfreeze",
  freezeAssessmentPrompt:
    "Are you sure you want to {{action}} this assessment?",
  expiresAt: "Expires At",
  seePreview: "See Preview",
  schedule: "Schedule",
  skillBenchmarking: "Skill Benchmarking",
  skillBenchmarkingOverview:
    "An overview of participant's proficiency in specific skills.",
  proctoringAnalysis: "Proctoring Analysis",
  proctoringAnalysisOverview:
    "A quick overview of the proctoring-related aspects of the assessment.",
  proctoringStatus: "Proctoring Status",
  noIrregularitiesReported: "No irregularities reported.",
  monitoringOverview: "Monitoring Overview",
  complianceNoIncidents:
    "Compliance with assessment rules; no incidents or flagged behaviors.",
  viewEvidenceClicked: "Clicked evidence!",
  marksObtained: "Marks Obtained",
  correctAnswer: "Correct Answer",
  wrongAnswer: "Wrong Answer",
  sectionWiseAnalysis: "Section wise Analysis",
  sectionWiseAnalysisOverview:
    "An overview of each question and the candidate's response.",
  openAllSections: "Open all sections",
  closeAllSections: "Close all sections",
  sectionWithNumber: "Section {{number}}:",
  score: "Score",
  questionAnalysis: "Question Analysis",
  questionTitleFallback: "Question Title",
  candidateAnswer: "Candidate Answer",
  loadAllQuestions: "Load all {{count}} {{item}}",
  attemptWithNumber: "Attempt #{{number}}",
  invalidReportUrl: "Invalid report URL",
  failedToDownloadReportTryAgainLater:
    "Failed to download report. Please try again later!",
  downloadReport: "Download Report",
  participantName: "Participant Name",
  dateOfAttempt: "Date of Attempt",
  fail: "Fail",
  pass: "Pass",
  userScoredInAssessment: "{{name}} scored {{percentage}} in assessment.",
  overallSummary: "Overall Summary",
  sectionAnalytics: "Section Analytics",
  allAttempts: "All Attempts",
  bestAttempt: "Best Attempt",
  latestAttempt: "Latest Attempt",
  participantList: "Participant List",
  totalParticipantsInvited: "Total Participants Invited",
  notStarted: "Not Started",
  inProgress: "In Progress",
  resultsInProgress: "Results In Progress",
  searchByNameOrEmail: "Search by name or email",
  noUsersAvailableReportCannotBeGenerated:
    "No users available - report cannot be generated.",
  userName: "User Name",
  totalAttempt: "Total Attempt",
  percentage: "Percentage",
  attemptTimeline: "Attempt Timeline",
  noDataFound: "No data found",
  outOfMarks: "{{obtained}} out of {{max}} marks",
  resultInProcess: "Result In Process",
  participantNotFound: "Participant not found!",
  searchedParticipantNotFound: "Searched participant not found!",
  noParticipantEnrolled: "No participant enrolled!",
  noDataToDisplay: "No data to display",
  participantsPerPage: "Participants per page:",
  actionFailed: "Action failed",
  failedToRemoveUser: "Failed to Remove User",
  bestScoreAcrossAttemptsInfo:
    "Indicates the best score achieved across multiple attempts.",
  successfullyRemovedUser: "Successfully removed the user",
  successfullyReinvitedUser: "Successfully re-invited the user",
  reinviteTooltip:
    "Re-invite participants who have not yet started the ongoing assessment",
  reInvite: "Re-invite",
  noParticipantsInvitedYet: "No participants have been invited yet",
  scheduleExpired: "Schedule Expired",
  assessmentIsOngoing: "Assessment is ongoing",
  assessmentCompleted: "Assessment Completed",
  resultNotProcessed: "Result not processed",
  assessmentNotStarted: "Assessment not started",
  remove: "Remove",
  confirmReInvitation: "Confirm Re-Invitation",
  confirmReinviteMessage:
    "Are you sure you want to re-invite participants who have not yet started the ongoing assessment?",
  removeUserWithNamePrompt: "Are you sure you want to remove '{{name}}'?",
  groupType: "Group Type",
  objectiveGroupType: "Objective",
  codingGroupType: "Coding",
  subjectiveTextSpeakingGroupType: "Subjective ( Text / Speaking )",
  groupTypeImmutableInfo:
    "Group type can't be changed later. Only questions of that type can be added.",
  sameMarkGroupingTitle:
    "Questions can only be grouped if they have the same mark value",
  sameMarkGroupingDescription:
    "Mixing mark values (e.g., 2-mark and 5-mark) in a group can lead to different section scores when only some questions are picked. Group similar mark questions to keep scores consistent.",
  searchQuestion: "Search Question",
  addAllSelectedQuestions: "Add all {{count}} selected questions",
  singleQuestionSelectedCount: "{{count}} question selected",
  allQuestionsSelectedCount: "All {{count}} questions selected",
  selectedCountOfTotalQuestions: "Selected {{selected}} of {{total}} {{label}}",
  addSelectedQuestion: "Add the selected question",
  validationErrors: "Validation Errors",
  failedToAddToGroup: "Failed to add to group",
  questionsAddedSuccessfullyWithCount: "{{count}} questions added successfully",
  successfullyUpdatedAssessment: "Successfully Updated Assessment",
  editCustomTnc: "Edit Custom Tnc",
  addCustomTnc: "Add Custom Tnc",
  attributes: "Attributes",
  added: "Added",
  addAttributes: "Add Attributes",
  clickHereToAddEditAttributes: "Click Here To Add Edit Attributes",
  clickHereToAddAttributes: "Click Here To Add Attributes",
  addTncAndSave: "Add Tnc And Save",
  savedWithFollowingErrors: "Saved With Following Errors",
  selectDomain: "Select Domain",
  selectRegion: "Select Region",
  selectUsage: "Select Usage",
  selectCategoryFirst: "Select Category First",
  selectSubCategory: "Select Sub Category",
  addAttributesAndSave: "Add Attributes And Save",
  questionPaperTimer: "Question Paper Timer",
  sectionLevelTimer: "Section Level Timer",
  questionLevelTimer: "Question Level Timer",
  loginWindowDescription:
    "Candidates can join only within a limited time window after the start time.",
  durationBasedDescription:
    "End time is auto-calculated from start time + test duration.",
  deadlineDescription:
    "Fixed start and end time; candidates must finish before the deadline.",
  loginWindowInfo:
    "Login Window is the time (in minutes) during which candidates can start the assessment after the scheduled start time. Once the login window closes, no new candidate can enter. The login window must be less than or equal to the question paper duration.",
  assessmentDurationInfo:
    "Set only the Start Time. The system will automatically calculate the End Time by adding the test duration.",
  startTimeMinAheadInfo:
    "Start time must be at least 15 minutes ahead of the current time.",
  loginWindowExample:
    "Example: If the start time is 9:00 AM and the login window is 30 minutes, candidates can start between 9:00-9:30 AM with extra 5 minutes buffer.",
  assessmentDurationExample:
    "Example: If Start Time is 9:00 AM and the test duration is 60 minutes, the assessment will end at 10:00 AM with extra 5 minutes buffer.",
  freeFlow: "Free Flow",
  oneByOne: "One By One",
  subjectiveNoResultInfo: "Subjective No Result Info",
  candidateResultVisibility: "Candidate Result Visibility",
  noResult: "No Result",
  passPercentageRangeError: "Pass Percentage Range Error",
  attemptsAllowedInfo: "Attempts Allowed Info",
  maxAttemptsError: "Max Attempts Error",
  maximumAttemptsInfo: "Maximum Attempts Info",
  limitedAttempts: "Limited Attempts",
  coolOffDescription: "Cool Off Description",
  noCoolOffPeriod: "No Cool Off Period",
  waitFor: "Wait For",
  hours: "Hours",
  days: "Days",
  whatLearnersWillSee: "What Learners Will See",
  unlimitedAttemptsInfo:
    "You have unlimited attempts available for this assessment.",
  waitBeforeNextAttemptPrefix: "After each attempt, you'll need to wait",
  waitBeforeNextAttemptSuffix: "before starting your next attempt.",
  waitBeforeNextAttempt:
    "After each attempt, you'll need to wait {duration} before starting your next attempt.",
  singleAttemptInfo: "You have 1 attempt available for this assessment.",
  remainingAttemptsInfoPrefix: "You have",
  remainingAttemptsInfoMiddle: "out of",
  remainingAttemptsInfoSuffix: "attempts available for this assessment.",
  remainingAttemptsInfo:
    "You have {remaining} out of {total} attempts available for this assessment.",
  enableCertificate: "Enable Certificate",
  enableCertificateDescription:
    "Issue a certificate to candidates upon successful assessment.",
  maxAllowed100: "Max Allowed100",
  scheduleAssessment: "Schedule Assessment",
  privateAssessmentLabel: "Private Assessment",
  publicAssessmentLabel: "Public Assessment",
  privateAssessmentDescription:
    "This assessment is invite-based only and is available strictly within the defined start and end time window.",
  publicAssessmentDescription:
    "This assessment supports both self-assigned and invite-based access, with no fixed access time window.",
  schedulePublicAssessment: "Schedule Public Assessment",
  successfullyPublishedAssessment: "Successfully Published Assessment",
  publishWithoutProctoringPrompt: "Publish Without Proctoring Prompt",
  publishAssessmentPrompt: "Publish Assessment Prompt",
  sectionScoreAnalysis: "Section Score Analysis",
  sectionScoreAnalysisOverview: "Section Score Analysis Overview",
  section: "Section",
  noSectionDataAvailable: "No Section Data Available",
  difficultyLevelAnalysis: "Difficulty Level Analysis",
  browserViolations: "Browser Violations",
  videoViolations: "Video Violations",
  times: "Times",
  statusMessageUnavailable: "Status Message Unavailable",
  viewViolationEvidence: "View Violation Evidence",
  noBrowserViolationsDetected: "No Browser Violations Detected",
  noVideoViolationsDetected: "No Video Violations Detected",
  candidateNotAttemptedCodingMessage: "Candidate Not Attempted Coding Message",
  candidateCode: "Candidate Code",
  candidateScore: "Candidate Score",
  compilationCount: "Compilation Count",
  submissionCount: "Submission Count",
  timeTaken: "Time Taken",
  testCaseReport: "Test Case Report",
  performanceAndCompilationMetrics: "Performance And Compilation Metrics",
  totalTestCases: "Total Test Cases",
  testCasesPassed: "Test Cases Passed",
  testCaseDetails: "Test Case Details",
  searchQuestions: "Search questions",
  clearSearch: "Clear Search",
  question: "question",
  isSelected: "is selected",
  areSelected: "are selected",
  selected: "Selected",
  questionsPerPage: "Questions per page:",
  publishQuestions: "Publish Questions",
  send: "Send",
  move: "Move",
  publishQuestionsConfirmation:
    "Are you sure you want to publish {{count}} {{label}}?",
  sendForReviewConfirmation:
    "Are you sure you want to send {{count}} {{label}} for review?",
  moveToDraftConfirmation:
    "Are you sure you want to move {{count}} {{label}} to draft?",
  bulkPublishDisclaimer:
    "Please verify that all selected questions are complete, accurate, and displayed as intended before publishing.",
  bulkReviewDisclaimer:
    "Please verify that all selected questions are complete, accurate, and displayed as intended before sending for review.",
  bulkDraftDisclaimer:
    "Please verify that all selected questions are complete, accurate, and displayed as intended before moving to draft.",
  questionsUnderProcess:
    "The questions are under process, please click on view details to check the questions status.",
  mixedStatusesSelected: "Mixed Statuses Selected",
  mixedStatusesWarning:
    "Please ensure all selected questions have the same status before proceeding.",
  selectionLimitReached: "Selection Limit Reached",
  selectionLimitWarning:
    "You cannot select more than {{count}} questions for a bulk action. Deselect a question before selecting another one.",
  knowMore: "Know more",
  guideLearnersRightDepth:
    "Guide your learners with questions that match the right depth.",
  bloomCreateDescription:
    "Assess the learner's ability to design, architect, or build new systems or code solutions using multiple concepts.",
  bloomEvaluateDescription:
    "Check if the learner can critically assess code, justify choices, or evaluate different solutions.",
  bloomAnalyzeDescription:
    "Test the learner's ability to break down code, debug, trace logic, or identify patterns in technical systems.",
  bloomApplyDescription:
    "Evaluate if the learner can apply concepts to solve practical coding problems or real-world scenarios.",
  bloomUnderstandDescription:
    "Check if the learner can understand and explain concepts in their own words or interpret behavior.",
  bloomRememberDescription:
    "Assess the learner's ability to recall basic definitions, syntax, and factual information.",
  bloomVerbCreate: "Create",
  bloomVerbDesign: "Design",
  bloomVerbConstruct: "Construct",
  bloomVerbDevelop: "Develop",
  bloomVerbEvaluate: "Evaluate",
  bloomVerbJustify: "Justify",
  bloomVerbDefend: "Defend",
  bloomVerbAssess: "Assess",
  bloomVerbAnalyze: "Analyze",
  bloomVerbDifferentiate: "Differentiate",
  bloomVerbOrganize: "Organize",
  bloomVerbCompare: "Compare",
  bloomVerbApply: "Apply",
  bloomVerbUse: "Use",
  bloomVerbDemonstrate: "Demonstrate",
  bloomVerbSolve: "Solve",
  bloomVerbExplain: "Explain",
  bloomVerbDescribe: "Describe",
  bloomVerbSummarize: "Summarize",
  bloomVerbInterpret: "Interpret",
  bloomVerbList: "List",
  bloomVerbDefine: "Define",
  bloomVerbName: "Name",
  bloomVerbRecall: "Recall",
  bloomVerbRecognize: "Recognize",
  bloomCreateExample1:
    "Create a single-page application using React and Redux.",
  bloomCreateExample2: "Design a schema for a ride-sharing app database.",
  bloomCreateExample3: "Develop a CI/CD pipeline using GitHub Actions.",
  bloomEvaluateExample1:
    "Evaluate the pros and cons of using NoSQL over SQL in a micro services architecture.",
  bloomEvaluateExample2:
    "Recommend improvements to optimize the React component's performance.",
  bloomAnalyzeExample1: "Compare the performance of merge sort and quicksort.",
  bloomAnalyzeExample2: "Analyze the memory usage of this recursive function.",
  bloomAnalyzeExample3:
    "Categorize the errors in this block of JavaScript code.",
  bloomApplyExample1:
    "Apply the binary search algorithm to find an element in an array.",
  bloomApplyExample2: "Use a loop to print the Fibonacci series in Python.",
  bloomApplyExample3: "Solve a real-world problem using a hash map.",
  bloomUnderstandExample1:
    "Explain how a stack works using the LIFO principle.",
  bloomUnderstandExample2:
    "Describe the difference between var, let, and const in JavaScript.",
  bloomUnderstandExample3: "Interpret the output of the given SQL query.",
  bloomRememberExample1: "Identify the correct HTML tag to create a hyperlink.",
  bloomRememberExample2:
    "Name the four pillars of Object-Oriented Programming (OOP).",
  bloomRememberExample3: "List the primitive data types in Java.",
  commonVerbs: "Common Verbs",
  exampleQuestions: "Example Questions",
  noExamplesAvailable: "No examples available.",
  candidateResponse: "Candidate Response",
  correctQuestions: "Correct Questions",
  totalQuestions: "Total Questions",
  correctQuestionPercentage: "Correct Question Percentage",
  performance: "Performance",
  level: "LEVEL",
  noOfQuestions: "NO OF QUESTIONS",
  correctAttempts: "CORRECT ATTEMPTS",
  correctness: "CORRECTNESS",
  partiallyCorrect: "PARTIALLY CORRECT",
  partiallyCorrectPercentage: "PARTIALLY CORRECT PERCENTAGE",
  rescheduleAssessmentPrompt:
    'Please confirm if you want to reschedule the assessment titled "{{title}}"',
  assessmentAlreadyStarted: "Assessment already started",
  readMore: "Read More",
  best: "Best",
  latest: "Latest",
  allQuestions: "All Questions",
  myQuestions: "My Questions",
  publicQuestions: "Public Questions",
  remarks: "Remarks",
  addRemarks: "Add Remarks",
  noGroupsAdded: "No groups added yet",
  addGroupInfo:
    "Start by creating a group to begin adding questions. Click the “Add Group to Section” button below to get started.",
  exitPreview: "Exit Preview",
  preview: "Preview",
  problemStatementNotAdded: "Problem statement not added",
  durationDayUnit: "day",
  durationDaysUnit: "days",
  durationHourUnit: "hr",
  durationHoursUnit: "hrs",
  durationMinuteUnit: "min",
  customFieldAddedForSingleLanguage:
    "Custom {{fieldLabel}} added for {{current}} out of {{total}} language",
  customFieldAddedForMultipleLanguages:
    "Custom {{fieldLabel}} added for {{current}} out of {{total}} languages",
  email: "Email",
  tagInputHint: "Add comma separated",
  enterOptions: "Enter options",
  groupNotFound: "Group not found",
  sheetNotFound: "Sheet not found",
  missingHeaders: "Required headers are missing",
  assetNotFound: "Asset not found",
  noValidDataFound: "No valid data found",
  notFoundPID: "Participant not found.",
  invalidParticipants: "Invalid participant.",
  alreadyAdded: "Participant already added.",
  duplicateData: "Duplicate data found.",
  invalidData: "Invalid data.",
  warnings: "Warnings",
  assignedToMyself: "Assigned to myself (Self Learning)",
  assignedByMe: "Assigned by me (My Assignments)",
  urlCopiedToClipboard: "URL copied to clipboard!",
  failedToCopyUrl: "Failed to copy URL.",
  content: "Content",
  platformHelp: "Platform Help",
  privacyPolicy: "Privacy Policy",
  logout: "Logout",
  logoutConfirmTitle: "Are you sure you want to log out?",
  logoutConfirmDescription:
    "Heading out? You can always come back and continue where you left off.",
  stayEngaged: "Stay Engaged"
} as const;

export default en;
